import { observer } from "mobx-react";
import TaskCloneStore from "../../stores/task/task-clone";
import { useStore } from "../../stores/root-store";
import { Card, Checkbox, CheckboxChangeEvent, Flex, Tag, Image, Button, Popconfirm } from "antd";
import Subjects from "../../models/subjects";
import TaskItemStore from "../../stores/task/task-item";

const CloneCard: React.FC<{ 
    task: TaskCloneStore, 
    subject: Subjects, 
    parent?: TaskItemStore, 
    markAsClone?: boolean,
    unmarkAsClone?: boolean }> = ({ task, subject, parent, markAsClone, unmarkAsClone }) => {

    const { subjectStores, fileService } = useStore();
    const newTicket = subjectStores[subject].newTicket;
    const ticketBar = subjectStores[subject].ticketBar;
    const { id } = task.data;

    const handleTicketAction = () => {
        newTicket.toggleTaskInTicket(id, ticketBar);
    }

    const handleNotClone = () => {
        if (parent) {
            parent.deleteClone(task);
        }
    }

    const handleChangeIsClone = (event: CheckboxChangeEvent) => {
        task.toggleClone(event.target.checked);
    }

    return <Card title={`Задача ${task.data.id}`} className='card'
        extra={
            <Flex align="flex-end" vertical>
                {markAsClone && <Checkbox onChange={handleChangeIsClone} checked={task.isClone}>Это клон</Checkbox>}
                <Button type="link" size="small" onClick={handleTicketAction}>{newTicket.contains(id) ? "Убрать из варианта" : "Добавить в вариант"}</Button>
                {unmarkAsClone && <Popconfirm
                    title="Вы уверены, что хотите снять метку клона?"
                    description="Отменить это действие будет невозможно"
                    onConfirm={handleNotClone}
                    okText="Да"
                    cancelText="Нет"
                >
                    <Button type="link" size="small" danger>Это не клон</Button>
                </Popconfirm>}
            </Flex>
        }
    >
        <Card.Meta
            description={
                <div>
                    <Tag color="magenta">{task.data.theme?.name}</Tag>
                    <Tag color='green'>{task.data.source.name}</Tag>
                    <Tag color="cyan">Номер в КИМ {task.data.numberInKim?.name}</Tag>
                    {task.data.tags.map(tag => <Tag key={tag}>{tag}</Tag>)}
                </div>
            }
        />
        {task.data.photoIds &&
            <Flex wrap="wrap" gap="small" style={{ marginTop: "20px" }}>
                <Image.PreviewGroup >
                    <Image key={task.data.photoIds[0]} width={500} src={fileService.getFileUrl(task.data.photoIds[0])} placeholder={true} />
                </Image.PreviewGroup>
            </Flex>
        }
    </Card>;
}

export default observer(CloneCard);